import { render, staticRenderFns } from "./RenewalInplayMobileDetail.vue?vue&type=template&id=18f8a5a0&scoped=true"
import script from "./RenewalInplayMobileDetail.vue?vue&type=script&lang=js"
export * from "./RenewalInplayMobileDetail.vue?vue&type=script&lang=js"
import style0 from "./RenewalInplayMobileDetail.vue?vue&type=style&index=0&id=18f8a5a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f8a5a0",
  null
  
)

export default component.exports